import { render, staticRenderFns } from "./consolidado_sistema.vue?vue&type=template&id=04d738da"
import script from "./consolidado_sistema.vue?vue&type=script&lang=js"
export * from "./consolidado_sistema.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports